import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink as Link } from 'react-router-dom';

const Tile = ({ venue, url, isLoading }) => {
  const isAddTile = !venue;

  const renderAddVenue = () => {
    return <Fragment>
      <h4 className="text-xl text-gray-500 leading-tight pb-3">
        <i className="fa fa-plus"></i>
      </h4>
      <p className="text-base text-gray-500 leading-normal">Add Venue</p>
    </Fragment>
  }

  const renderVenue = () => {
    return <Fragment>
      <img alt={venue.name} src={venue.image} className="h-40 w-full rounded-t-lg"/>
      <p className="font-bold text-base text-gray-900 leading-normal py-4">{venue.name}</p>
    </Fragment>
  }

  const renderLoading = () => {
    return <Fragment>
      <div className="h-40 w-full rounded-t-lg bg-gray-500"></div>
      <div className="py-4 px-12 mb-2">
        <div className="h4 w-full bg-gray-500">&nbsp;</div>
      </div>
    </Fragment>
  }

  const contentClass = `w-full text-center ${isAddTile && !isLoading ? 'py-20' : ''}`;
  const linkClass = `w-136 mr-6 mb-4 flex flex-initial bg-white rounded-lg shadow-md ${isLoading ? 'pointer-events-none' : 'cursor-pointer'}`

  return (
    <Link to={url} className={linkClass}>
      <div className={contentClass}>
        { (isLoading && renderLoading()) || (isAddTile ? renderAddVenue() : renderVenue()) }
      </div>
    </Link>
  );
}

Tile.defaultProps = {
  venue: false,
  isLoading: false,
  url: '',
}

Tile.propTypes = {
  venue: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  isLoading: PropTypes.bool,
  url: PropTypes.string,
}

export default Tile;
